import { onBeforeUnmount, onMounted, ref } from 'vue'

export function isMobileNow(targetWidth = 768) {
  if (typeof window === 'undefined') return false
  return window.innerWidth < targetWidth
}

export function useIsMobile(targetWidth = 768) {
  const isMobile = ref(false)

  const updateIsMobile = () => {
    isMobile.value = isMobileNow(targetWidth)
  }

  onMounted(() => {
    updateIsMobile()
    window.addEventListener('resize', updateIsMobile, { passive: true })
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateIsMobile)
  })

  return { isMobile, updateIsMobile }
}

